import { render, staticRenderFns } from "./CeoModeration.vue?vue&type=template&id=2a8bfb7e&scoped=true"
import script from "./CeoModeration.vue?vue&type=script&lang=js"
export * from "./CeoModeration.vue?vue&type=script&lang=js"
import style0 from "./CeoModeration.vue?vue&type=style&index=0&id=2a8bfb7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8bfb7e",
  null
  
)

export default component.exports